'use client';

const faqs = [
  {
    question: 'How does The Way Maker work?',
    answer: 'The Way Maker provides a platform for churches and organizations to create interactive maps and experiences that showcase their sacred spaces, artwork, and donor recognition. You can manage content through our admin interface and share it with your community.',
  },
  {
    question: 'Do I need technical expertise to use it?',
    answer: 'No! The Way Maker is designed to be intuitive and easy to use. Our admin interface makes it simple to add content, create maps, and manage your site without any coding knowledge.',
  },
  {
    question: 'Can I customize the look and feel?',
    answer: 'Yes! Professional and Enterprise plans include custom branding options, allowing you to match your organization\'s visual identity and create a cohesive experience for your community.',
  },
  {
    question: 'Is my data secure?',
    answer: 'Absolutely. We use enterprise-grade security measures to protect your data and donor information. All data is encrypted in transit and at rest, and we follow industry best practices for security and privacy.',
  },
  {
    question: 'What kind of support do you offer?',
    answer: 'All plans include email support. Professional plans include priority support, and Enterprise plans include dedicated account management and on-site training options.',
  },
  {
    question: 'Can I try it before committing?',
    answer: 'Yes! We offer a free trial period so you can explore all the features and see how The Way Maker can work for your organization. Contact us to get started.',
  },
];

export function FAQ() {
  return (
    <section className="py-16 md:py-24 px-4 bg-stone/20 border-t border-border/5">
      <div className="max-w-4xl mx-auto">
        <div className="text-center space-y-5 mb-16">
          <h2 className="text-3xl md:text-4xl font-spectral font-semibold mb-3">Frequently Asked Questions</h2>
          <p className="text-foreground/60 text-lg leading-relaxed">
            Have questions? We've got answers.
          </p>
        </div>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={index !== faqs.length - 1 ? 'pb-8 border-b border-border/10' : ''}
            >
              <h3 className="text-lg font-spectral font-semibold text-foreground mb-3">
                {faq.question}
              </h3>
              <p className="text-base text-foreground/70 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
